import { BigNumber } from 'bignumber.js'

const common = {
  VALUE_RATE: {
    number: 1000000,
    label: '百万円',
  },

  // 3桁ずつカンマで区切っていく
  separate_every_3digits: function(number) {
    if (number >= 1000) {
      return String(number).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    } else {
      return number;
    }
  },

  change_value_rate: function(number) {
    return new BigNumber(number / this.VALUE_RATE.number).toFixed(0, BigNumber.ROUND_DOWN);
  },
};

export default common;



// WEBPACK FOOTER //
// ./src/common.js